type ErrorMessage =
  | { readonly message?: string; readonly userPresentableMessage: string }
  | string;

export abstract class BaseError extends Error {
  public override readonly name: string = "BaseError";

  public readonly userPresentableMessage: string | undefined;

  public constructor(message?: ErrorMessage, errorOptions?: ErrorOptions) {
    const normalized =
      typeof message === "object"
        ? (message.message ?? message.userPresentableMessage)
        : message;

    const userPresentableMessage =
      typeof message === "object" ? message.userPresentableMessage : undefined;

    super(normalized, errorOptions);
    this.userPresentableMessage = userPresentableMessage;
  }
}
